<template>
  <!-- 目的国家搜索 -->
  <div class="inputSearch">
    <input type="text" class="inputSear" v-model="inputText" ref="ipt" :placeholder="setPlaceholder" :style="{width:setWidth,height:height,}" @focus="focusInput" @keydown="keydown($event)" @input="getInputVal(inputText)" @blur="blurInput" @click="RecentShow" />
    <div v-show="isShow != 3" class="dataBox" style="width:246px;" id="DesCountry">
      <div v-show="isShow == 0">
        <div class="Recent"> My Records</div>
        <el-scrollbar style="height:100%;min-width: 246px">
          <div style="text-align: center;padding: 5px;" v-show="!Recent.length">No result</div>
          <ul v-show="Recent.length" style="max-height: 200px">
            <li class="es" v-for="(item,index) in Recent" :key="index" @click="getText(item)" :class="{isActive:index==isIndex}" @mouseover="clearKeydown(index)">{{item.NameEn}}{{"("+item.CountryCode+")"}}</li>
          </ul>
        </el-scrollbar>
      </div>
      <div v-show="isShow != 2">
        <div v-show="isShow != 2" class="Recent">Deliverable Countries</div>
        <el-scrollbar style="height:100%;">
          <ul v-show="isShow != 2" style="max-height: 300px">
            <li class="es" v-for="(item,index) in queryList" :key="index" @click="getText(item)" :class="{isActive:(isShow==0 ? Recent.length+index :index)==isIndex}" @mouseover="clearKeydownQuery(index)">{{item.NameEn}}{{"("+item.CountryCode+")"}}</li>
            <div v-show="!queryList.length" style="text-align: center;padding: 5px;">No result</div>
          </ul>
          <ul v-show="isShow == 2">
            <div class="Recent">Deliverable Countries</div>
            <div style="text-align: center;padding: 5px;">No result</div>
          </ul>
        </el-scrollbar>
      </div>
      <!-- 模糊搜索 end -->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import bus from '@/ask/eventBus';
import { getCustomer, setCustomer } from "@/utils/getCustomer";
import { post, fetch, Del, put } from "@/ask/axios";
export default {
  props: {
    setPlaceholder: { type: String }, //输入框默认值
    setWidth: { type: String }, //宽度
    height: { type: String }, //高度
    setData: { type: String }, //
    Recent: { type: Array }, //最近列表
  },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      isShow: 3, //0是否显示最近查询 1:数据显示，2：数据无结果显示 3.不显示
      inputFocus: true, //聚焦
      inputText: '',//输入
      disappear: true,
      key: "",
      AllList: [],//所有列表
      queryList: [],
      isIndex: -1,
      curList: '',//当前list
      isWCA: false,
      setKey: '',
      userInfo: '',
    }
  },
  created() {
    this.chooseUS()
    this.getCountry() //国家所有信息
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.inputFocus) {
        var sp = document.getElementById("DesCountry");
        if (sp && !sp.contains(e.target)) {
          this.isShow = 3
        }
      }
    })
    setTimeout(() => {
      if (this.setData !== '') {
        this.curList = this.AllList.filter(item => item.CountryKey === this.setData)[0]
        var curText = `${this.curList.NameEn}(${this.curList.CountryCode})`
        this.inputText = curText;
        this.$emit('byCountryValue', this.curList)
      }
    }, 1000)
  },
  watch: {

  },

  computed: { //计算属性函数
  },
  methods: {
    chooseUS() {
      getCustomer().then((Customer) => {
        //console.log(Customer,"CustomerInfo")
        this.userInfo = Customer
        this.isWCA = Customer.IsWCA
        this.setKey = this.userInfo.WCAQueryCountryKey
      }).catch((error) => {
      })
      if (this.setData !== '') {
        return false
      }
      // 如果没有选美国
      if (this.setKey) {
        this.curList = this.AllList.filter(item => item.CountryKey.toUpperCase() === this.setKey.toUpperCase())[0];
        var curText = `${this.curList.NameEn}(${this.curList.CountryCode})`
        this.inputText = curText;
        this.$emit('byCountryValue', this.curList)
        return
      }
      if (!this.Recent[0]) {
        this.curList = {
          CountryCode: "US",
          CountryKey: "4ae00ac2-0673-4b13-83fc-e15c72909610",
          NameCh: "美国",
          NameEn: "United States",
        }
        var curText = `${this.curList.NameEn}(${this.curList.CountryCode})`
        this.inputText = curText;
        this.$emit('byCountryValue', this.curList)
      } else {
        this.curList = this.Recent[0]
        var curText = `${this.curList.NameEn}(${this.curList.CountryCode})`
        this.inputText = curText;
        this.$emit('byCountryValue', this.curList)
      }

    },
    getCountry() {
      this.api.param = {
      }
      this.api.url = this.$api04 + "/Air/api/DestSvc/QueryDestSvcCountry"
      post(this.api.url, this.api.param).then((res) => {
        if (res.Results) {
          if (res.Results.length > 0) {
            var Data = this.changeTreeDate(res.Results, "CountryNameCh", "CountryNameCn")
            Data = this.changeTreeDate(Data, "CountryID", "CountryCode")
            var Opt = res.Results.filter((item) => {
              return item.CountryID !== 'US0' && item.CountryID !== 'US2' && item.CountryID !== 'US1'
            })
            let resList = Opt
            // 由于后面传入的字段不一样 所以转一下
            resList = JSON.stringify(resList)
            resList = resList.replace(/CountryID/g, 'CountryCode')
            resList = resList.replace(/CountryNameCh/g, 'NameCh')
            resList = resList.replace(/CountryNameEn/g, 'NameEn')
            this.AllList = JSON.parse(resList)
            this.$emit("getDesv", this.AllList)

          }
        }
      });
    },
    changeTreeDate(jsonObj, newKey, oldKey) {
      let str = JSON.stringify(jsonObj);
      let reg = new RegExp(oldKey, 'g');
      let newStr = str.replace(reg, newKey);
      return JSON.parse(newStr);
    },
    // 聚焦
    focusInput: function (e) {
      this.isShow = 0
      this.inputFocus = true
      this.queryList = this.AllList
      this.$refs.ipt.select(); // or e.currentTarget.select();
    },

    //货物input输入框输入值
    getInputVal() {
      let inputVal = this.inputText
      let res = JSON.parse(JSON.stringify(this.AllList))
      if (inputVal) {
        //console.log(inputVal)
        this.isShow = 1
        res = res.filter((item) => {
          if (item.NameEn.toUpperCase().indexOf(inputVal.toUpperCase()) !== -1 || item.CountryCode.toUpperCase().indexOf(inputVal.toUpperCase()) !== -1) {
            return item
          }
        })
        let flag = false
        for (let index = 0; index < res.length; index++) {
          const ele = res[index];
          if (!flag) {
            if (ele.CountryCode.toUpperCase() == inputVal.toUpperCase()) {
              res.splice(index, 1)
              res.unshift(ele)
              flag = true
            }
          }
        }
      }
      this.queryList = res
    },

    RecentShow() {
      if (this.isShow == 3) {
        this.isShow = 0
      }
    },

    //鼠标移入时清除键盘事件
    clearKeydown(index) {
      this.isIndex = index;
    },
    //鼠标移入时清除键盘事件
    clearKeydownQuery(index) {
      if (this.isShow == 0) {
        index = this.Recent.length + index
      }
      this.isIndex = index;
    },

    // 键盘方法
    keydown(e) {
      let showList = ''
      let allList = this.Recent.concat(this.queryList)
      if (this.isShow == 0) {
        showList = allList.length
      } else {
        showList = this.queryList.length
      }
      if (e.keyCode == 40) {//下键
        this.isIndex++;
        if (this.isIndex > showList - 1) {
          this.isIndex = 0;
        }
      } else if (e.keyCode == 38) {//上
        this.isIndex--;
        if (this.isIndex < 0) {
          this.isIndex = showList - 1;
        }
      } else if (e.keyCode == 13) {//回车
        if (this.isIndex >= 0) {
          if (this.isShow == 0) {
            this.curList = allList[this.isIndex]
          } else {
            this.curList = this.queryList[this.isIndex]
          }
          var curText = `${this.curList.NameEn}(${this.curList.CountryCode})`
          this.inputText = curText;
          this.isShow = 3
          this.disappear = false
          this.$emit('byCountryValue', this.curList)
        }
        this.isIndex = -1;
      }
    },

    //列表点击事件
    getText(item) {
      var curText = `${item.NameEn}(${item.CountryCode})`
      this.curList = item
      this.inputText = curText; //text赋值
      this.isShow = 3 //关闭下拉框
      this.disappear = false
      this.$emit('byCountryValue', this.curList)

      //传值到父组件
    },

    blurInput() {
      this.inputFocus = false
      // 延迟等待getText事件
      this.disappear = true
      setTimeout(() => {
        var curText = `${this.curList.NameEn}(${this.curList.CountryCode})`
        if (this.inputText != curText && this.disappear) {
          this.inputText = ''
          this.curList = ''
        }
        // this.isShow = 3
        this.$emit('byCountryValue', this.curList)
      }, 200)
    },
  },
}
</script>
<style lang="css" scoped>
.inputSearch {
  position: relative;
}
.inputSear {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 5px;
}
.dataBox {
  overflow-x: hidden;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  position: absolute;
  top: 31px;
  left: 0px;
  z-index: 66;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.dataBox ul li {
  cursor: pointer;
  color: #888;
}
.dataBox ul li:hover {
  background: #f5f7fa;
}
.dataBox ul li {
  padding: 0 5px;
}
.Recent {
  font-weight: 700;
  padding-left: 6px;
}
.isActive {
  background-color: #f5f7fa !important;
}
.es {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sepTipsMsg {
  color: #999;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/air/component/desCountry.vue